import React from 'react';

const StatusLegend = ({ viewMode }) => {
  return (
    <div className="mt-8 flex flex-wrap justify-center items-stretch space-x-4">
      <div className="flex items-center mb-2">
        <div className="w-6 h-6 rounded-full bg-green-100 mr-2"></div>
        <span className="text-base">{viewMode === 'admin' ? 'Available' : 'Get in Touch'}</span>
      </div>
      {viewMode === 'admin' ? (
        <>
          <div className="flex items-center mb-2">
            <div className="w-6 h-6 rounded-full bg-red-100 mr-2"></div>
            <span className="text-base">Occupied</span>
          </div>
          <div className="flex items-center mb-2">
            <div className="w-6 h-6 rounded-full bg-gray-100 mr-2"></div>
            <span className="text-base">Not Yet Available</span>
          </div>
        </>
      ) : (
        <div className="flex items-center mb-2">
          <div className="w-6 h-6 rounded-full bg-gray-100 mr-2"></div>
          <span className="text-base">Not Available</span>
        </div>
      )}
    </div>
  );
};

export default StatusLegend;